import slugify from 'slugify'

export const canBeSlugged = (text: string): boolean => {
  const sanitizedText = text
    .replace(/[.|<>:!()$%*\-+&¢£¤¥'"`~]/g, '')

  const maybeSlug = slugify(sanitizedText)

  return maybeSlug !== ''
}
